import { FormControl, FormHelperText, MenuItem, Select as MuiSelect, SelectProps as MuiSelectProps } from '@mui/material';
import { forwardRef } from 'react';

export interface SelectOption {
  value: string;
  label: string | React.ReactNode;
  disabled?: boolean;
  rightSection?: React.ReactNode;
}

interface SelectProps extends Omit<MuiSelectProps, 'error'> {
  options: SelectOption[];
  error?: boolean;
  helperText?: string;
  placeholder?: string;
}

const Select = forwardRef<any, SelectProps>(({ options, error, helperText, placeholder = '', ...props }, ref) => {
  return (
    <FormControl fullWidth error={error}>
      <MuiSelect
        {...props}
        ref={ref}
        displayEmpty
        size="small"
        MenuProps={{ PaperProps: { sx: { maxHeight: 240 } } }}
        sx={{
          '& .MuiSelect-select': {
            padding: '10px',
            backgroundColor: '#fff',
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#D0D5DD',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#9ca3af',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#3D9F4A',
            borderWidth: '2px',
          },
          '&.Mui-disabled': {
            backgroundColor: '#f3f4f6',
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#e5e7eb',
            },
            '& .MuiSelect-select': {
              color: '#9ca3af',
              WebkitTextFillColor: '#9ca3af',
              opacity: 0.6,
              cursor: 'not-allowed',
            },
          },
          borderRadius: '8px',
          ...props.sx,
        }}
        renderValue={(selected) => {
          if (!selected) {
            return <span style={{ color: '#9ca3af' }}>{placeholder}</span>;
          }
          const found = options.find((opt) => opt.value === selected);
          return found ? found.label : '';
        }}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value} disabled={option.disabled}>
            {option.label}
          </MenuItem>
        ))}
      </MuiSelect>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
});

Select.displayName = 'Select';

export default Select;
